export default __webpack_public_path__ + "static/media/city.e7200fcd.svg";